import { render, staticRenderFns } from "./ColorDetail.vue?vue&type=template&id=19678ec2"
import script from "./ColorDetail.vue?vue&type=script&lang=ts"
export * from "./ColorDetail.vue?vue&type=script&lang=ts"
import style0 from "./ColorDetail.vue?vue&type=style&index=0&id=19678ec2&prod&lang=styl"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports